module.exports = __webpack_public_path__ + "img/slide-32.8ee3945d.jpeg";